import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useLocation, useNavigate } from "react-router";
import { useAlert } from "../../../context/AlertProvider";
import {
  deleteAccountTeam,
  getAllTeams,
} from "../../../actionCreator/teamManagementActionCreator";

export const useTeamManagement = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { showAlert } = useAlert();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");
  const sort = searchParams.get("sort");
  const [loading, setLoading] = useState();
  const teams = useSelector((state) => state.teamManagementReducer.teams);

  const onFilterChange = (key, val) => {
    if (val !== undefined && val !== "all") {
      searchParams.set(key, val);
    } else {
      searchParams.delete(key);
    }
    navigate(`${location.pathname}?${searchParams.toString()}`);
  };

  const handleDelete = async (team) => {
    setLoading(true);
    const res = await dispatch(deleteAccountTeam(team?.id));
    if (res?.status === 204) {
      showAlert("success", `${team?.teamName} deleted successfully!`);
      if (teams?.content?.length === 1) {
        onFilterChange("page", page ? page - 1 : 1);
      } else {
        dispatch(
          getAllTeams({
            page: page
              ? teams?.content?.length === 1
                ? page - 2
                : page - 1
              : 0,
          })
        );
      }
    } else {
      showAlert("error", "Something went wrong. Please try again.");
    }
    setLoading(false);
  };

  useEffect(() => {
    const allParams = {};
    for (const [key, value] of searchParams.entries()) {
      allParams[key] = value;
    }
    dispatch(
      getAllTeams({
        ...allParams,
        page: allParams?.page ? allParams?.page - 1 : 0,
      })
    );
  }, [dispatch, searchParams]);
  
  useEffect(() => onFilterChange("page", 1), [sort]);

  return { teams, handleDelete, loading, onFilterChange };
};
